import { Modal, Typography } from 'antd';

import { Button } from '@shared/components';

const ChartSource = () => {
  const onClose = () => {
    Modal.destroyAll();
  };

  return (
    <div className="flex flex-col items-center">
      <Typography.Text className="mb-2 text-base font-bold">Chart Source</Typography.Text>
      <Typography.Text className="mb-4 text-center text-sm">
        Growth charts for 0-6 years old are from the Anthropometric Study on Pre-School Children in Singapore, 2000
        National Healthcare Group Polyclinics
      </Typography.Text>

      <Typography.Text className="mb-4 text-center text-sm">
        Growth charts for 7-18 years old are from the Anthropometric Study on School Children in SIngapore, 2002 Health
        Promotion Board
      </Typography.Text>
      <Button className="json-checked w-full" onClick={onClose}>
        Close
      </Button>
    </div>
  );
};

export default ChartSource;
